export default "Neden\nKaç tane\nnasıl"